import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { performGetRequest } from '@atlassian/jira-fetch';

export type JNAApp = {
	id: string;
	name: string;
	appVersion: String;
	synced: boolean;
};

export const listJNAAppsEndpoint = (cloudId: string) =>
	performGetRequest<{
		values: JNAApp[];
	}>(`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/notification/devices`).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'listJNAAppsEndpoint',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});
